import { useState } from 'react';
import { DEMAND, DEMAND_TYPE } from '@demandproai/shared';
import { useDownloadOptions } from './useDownloadOptions';

const READY_TOOLTIP = 'Download Medical Chronology';
const MISSING_TOOLTIP = 'Medical chronology has not been generated for this case yet';
const LOADING_ICON = 'fa fa-spinner animate-spin';
const IDLE_ICON = 'fa fa-file-medical';
const CHRONOLOGY_DOCX_KEY = DEMAND_TYPE?.[DEMAND.Medical_Chronology]?.key;

// Button state for downloading the case's medical chronology docx. The document covers
// every client on the case, so it takes no client scoping - the download endpoint only
// honours clientId for the cost projection demand. Gating on the stored s3 path keeps the
// endpoint's "Demand Draft Not Found" error away from users who never generated it.
const useLifecareChronologyDownload = ({ caseId, docxFiles }) => {
  const { downloadDemandDraft } = useDownloadOptions();
  const [isDownloading, setIsDownloading] = useState(false);

  const hasChronology = Boolean(docxFiles?.[CHRONOLOGY_DOCX_KEY]?.s3UrlPath);

  const handleDownload = async () => {
    if (!caseId || !hasChronology) return;
    setIsDownloading(true);
    try {
      await downloadDemandDraft({ caseId, typeOfDemandDraft: DEMAND.Medical_Chronology });
    } finally {
      setIsDownloading(false);
    }
  };

  return {
    tooltipTitle: hasChronology ? READY_TOOLTIP : MISSING_TOOLTIP,
    icon: isDownloading ? LOADING_ICON : IDLE_ICON,
    disabled: !caseId || !hasChronology || isDownloading,
    onClick: handleDownload,
  };
};

export default useLifecareChronologyDownload;
